import { FlagExtraLite } from "../flags";
import { LanguageSkill } from "./language-skill.model";

export class Language {
    constructor(
        public id : number, // 78
        public iso : string, // de // also known as languageKey or iso_639_1
        public name :string,  // 'languages.de' // Is this correct? Is this the full name ('German') or the translation key in common translation file
        public flag : FlagExtraLite,
        public flag_path?: string, // 'assets/images/flags/DE.png' // deprecated
        public flag_class?: string, // 'assets/images/flags/DE.png' // deprecated
        public skill?: LanguageSkill,
    ) {}
  }